import { render, staticRenderFns } from "./SponsorManagement.vue?vue&type=template&id=3509c3b5&scoped=true"
import script from "./SponsorManagement.vue?vue&type=script&lang=js"
export * from "./SponsorManagement.vue?vue&type=script&lang=js"
import style0 from "./SponsorManagement.vue?vue&type=style&index=0&id=3509c3b5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3509c3b5",
  null
  
)

export default component.exports